import React from 'react';
import { ArrowRight } from 'lucide-react';
import { CELEBRITIES } from '../data/mock';
import SectionHeading from './SectionHeading';

const Celebrities = () => {
  return (
    <section id="celebrities" className="section-pad bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHeading
          eyebrow="Proud to have served"
          title="India's Biggest Celebrities &"
          accent="Grand"
          tail="Events"
          subtitle="From Bollywood weddings to national ceremonies — a taste of the milestones we've been part of."
        />

        <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
          {CELEBRITIES.map((c, i) => (
            <article
              key={c.name}
              className="coco-card relative rounded-3xl bg-white border border-pink-100 overflow-hidden shadow-soft"
              style={{ animationDelay: `${i * 50}ms` }}
              data-testid={`celebrity-card-${c.name.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-blush">
                <img src={c.image} alt={c.name} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
                <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/70 to-transparent" />
              </div>
              <div className="p-4 relative">
                <div className="font-display font-semibold text-stone-900 leading-tight">{c.name}</div>
                <div className="text-xs text-stone-500 mt-0.5">{c.role}</div>
              </div>
            </article>
          ))}

          {/* + Many More tile */}
          <article className="rounded-3xl bg-gradient-to-br from-pink-brand to-pink-600 text-white p-6 flex flex-col justify-between shadow-pink-glow">
            <div>
              <div className="font-display font-bold text-3xl leading-tight">+ Many More</div>
              <div className="text-sm text-pink-100 mt-2">Celebrities, Politicians &amp; Sports Stars we've had the honour of serving.</div>
            </div>
            <button
              type="button"
              className="mt-6 inline-flex items-center gap-1 text-sm font-semibold w-fit rounded-full bg-white/15 hover:bg-white/25 px-4 py-2 backdrop-blur-sm"
              data-testid="celebrities-view-all-button"
            >
              View All <ArrowRight className="w-3.5 h-3.5" />
            </button>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Celebrities;
